import { Box, Switch, Typography } from '@mui/material';
import { useLanguage } from '../i18n/LanguageContext';

const flagStyle = { display: 'block', borderRadius: 2, boxShadow: '0 0 0 1px rgba(0,0,0,0.15)' } as const;

// Flagi jako inline SVG, nie emoji — Windows nie renderuje emoji flag (pokazuje litery "GB"/"PL").
const UnionJack = () => (
    <svg viewBox="0 0 60 30" width="36" height="18" aria-hidden="true" style={flagStyle}>
        <clipPath id="uj-s"><path d="M0,0 v30 h60 v-30 z" /></clipPath>
        <clipPath id="uj-t"><path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" /></clipPath>
        <g clipPath="url(#uj-s)">
            <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
            <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
            <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#uj-t)" stroke="#C8102E" strokeWidth="4" />
            <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
            <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
        </g>
    </svg>
);

const PolishFlag = () => (
    <svg viewBox="0 0 16 10" width="36" height="22" aria-hidden="true" style={flagStyle}>
        <rect width="16" height="5" y="0" fill="#fff" />
        <rect width="16" height="5" y="5" fill="#DC143C" />
    </svg>
);

/**
 * Przełącznik języka — wyśrodkowana "pigułka" nad powitaniem.
 * Pokazuje zawsze język, NA KTÓRY można się przełączyć: przy polskim interfejsie
 * flagę brytyjską i "English version", przy angielskim — polską flagę i "wersja polska".
 */
const LanguageSwitch = () => {
    const { lang, setLang, t } = useLanguage();
    const isEnglish = lang === 'en';

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
                component="label"
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1.5,
                    cursor: 'pointer',
                    userSelect: 'none',
                    padding: '8px 12px 8px 18px',
                    borderRadius: '999px',
                    border: '2px solid #00796B',
                    backgroundColor: isEnglish ? '#00796B' : '#E0F2F1',
                    color: isEnglish ? '#fff' : '#1A202C',
                    boxShadow: '0 2px 8px rgba(0, 121, 107, 0.25)',
                    transition: 'background-color 0.2s, color 0.2s',
                }}
            >
                {isEnglish ? <PolishFlag /> : <UnionJack />}
                <Typography sx={{ fontSize: '16px', fontWeight: 600, whiteSpace: 'nowrap' }}>
                    {isEnglish ? t('lang.polish') : t('lang.english')}
                </Typography>
                <Switch
                    checked={isEnglish}
                    onChange={(e) => setLang(e.target.checked ? 'en' : 'pl')}
                    inputProps={{ 'aria-label': isEnglish ? 'wersja polska' : 'English version' }}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': { color: '#fff' },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: '#00D2B4', opacity: 1 },
                        '& .MuiSwitch-track': { backgroundColor: '#9e9e9e', opacity: 1 },
                    }}
                />
            </Box>
        </Box>
    );
};

export default LanguageSwitch;
